import React, {useState, Fragment, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input,Row, Col, Label  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
// import { pharmacyCategory, pharmacytableColumns } from '../../../../Data/GeneralSettings';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import RequiredField from '../../../../Constant';
import CommonModal from '../../../Common/Component/CommonModal';
import { CreatePharmacyCategory, DeletePharmacyCategory, PharmacyCategoryList, UpdatePharmacyCategory } from '../../../../apiController';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';
const PharmacyCategory = () =>{

  const [Large, setLarge] = useState(false);

  const permission = roles_permissions.find(
    (module) => module.module_name === "Pharmacy Category"
  );

  const LargeModaltoggle = () => {setLarge(!Large);reset({phamarcycategory:''})};

  const [formdata, setFormdata] = useState({});
  const [pharmacy, setPharmacy] = useState([]);


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const handleEdit = (row) => {
    console.log(row)
    setFormdata({ id: row.id, pharmacycategory: row.name });
    setLarge(!Large);
    reset({id: row.id,  pharmacycategory: row.name });
  };

  const pharmacyCategory = pharmacy.map( (row, ind) =>(
    {
        ind: ind+1,
        id: row.id,
        pharmacycategory: row.name,
        action: 
        (
            <span>
                <Btn
                    attrBtn={{
                        style: {width: 60, fontSize: 14, padding: 4 },
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: () => handleEdit(row)
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    })
  );



  const pharmacytableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: false,
    },
    {
        name: 'Category',
        selector: row => row['pharmacycategory'],
        sortable: true,
        center: false,
    },
    // {
    //     name: 'Action',
    //     selector: row => row.action,
    //     sortable: false,
    //     center: true,
    // },
];

if (permission?.edit_access) {
  pharmacytableColumns.push({
    name: "Action",
    selector: (row) => row["action"],
    sortable: false,
    center: true,
  });
}

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(pharmacyCategory);

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);
    const handleSaveForm = async (data) => {
      const formattedData = {
          name: data.pharmacycategory,
          id: formdata.id
      };
  
      try {
          if (formdata.id) {
              const response = await UpdatePharmacyCategory(formattedData);
              if (response.status === true) {
                setPharmacy(prev => prev.map(item => item.id === formdata.id ? { ...item, name: formattedData.name } : item));
                  toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });

                  setTimeout(() => {
                    window.location.reload();
                    }, 2000);
              }
          } else {
              const response = await CreatePharmacyCategory(formattedData);
              if (response.status === true) {
                setPharmacy(prev => [...prev, response.data]);
                  toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              }
          }
          fetchPharmacyCategory();
          LargeModaltoggle();
      } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
      reset({ diagnosistype: '' });
  };
  
  
  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: 'Are you sure you want to delete?',
      cancelButtonText: 'No!',
      confirmButtonText: 'Yes!',
      reverseButtons: true,
      showCancelButton: true,
    });
  
    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map(row => row.id); 
        await Promise.all(selectedIds.map(id => DeletePharmacyCategory(id)));
        setPharmacy(pharmacy.filter(item => !selectedIds.includes(item.id)));
        setSelectedRows([]);
        toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
      } catch (error) {
        toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
    }
  };





    const fetchPharmacyCategory = async () => {
      const response = await PharmacyCategoryList();
      if (response.status === true) {
        setPharmacy(response.data);
      }
    };
  
    useEffect(()=>{
      fetchPharmacyCategory()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Pharmacy Category' parent='Dashboard' title='pharmacycategory' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary',onClick: LargeModaltoggle }}>+ Add Pharmacy Category</Btn>
            <CommonModal isOpen={Large} title={"Pharmacy Category"} toggler={LargeModaltoggle} size="lg" onSave={handleSubmit(handleSaveForm)} formdata={formdata}>
              <Row>
            <Col sm="12">
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Pharmacy Category"} <RequiredField/></Label>
              <input className={`form-control ${errors.pharmacycategory && "is-invalid"}`} id="pharmacycategory" type="text" name="pharmacycategory" defaultValue={formdata.pharmacycategory || ""} {...register("pharmacycategory", { required: true })} />
              <span className="text-danger">{errors.pharmacycategory && "Pharmacy Category is required"}</span>
            </FormGroup>
            </Col>
            </Row>
            </CommonModal>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={pharmacyCategory}
                columns={pharmacytableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows  = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default PharmacyCategory